import React from "react";

import { Alert } from "@mui/material";

interface ErrorMessageProps {
  message: string | null;
  sx?: object;
  onClose?: () => void;
}

export function ErrorMessage({ message, sx, onClose }: ErrorMessageProps) {
  if (!message) return null;
  return (
    <Alert severity="error" onClose={onClose} sx={{ mb: 2, ...sx }}>
      {message}
    </Alert>
  );
}
